import * as z from 'zod';

import { noteContextTypeSchema } from './notes-query-schema';

export const noteFormSchema = z.object({
  message: z.string().min(1, 'Message is required'),
  type: noteContextTypeSchema,
});

export type NoteFormSchema = z.infer<typeof noteFormSchema>;
